<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64 144C64 135.2 71.2 128 80 128L183.3 128C214 128 242.9 142.7 260.9 167.5L341 277.6C353 294.2 372.3 304 392.8 304L521.4 304L468.7 251.3C462.5 245.1 462.5 234.9 468.7 228.7C474.9 222.5 485.1 222.5 491.3 228.7L571.3 308.7C577.5 314.9 577.5 325.1 571.3 331.3L491.3 411.3C485.1 417.5 474.9 417.5 468.7 411.3C462.5 405.1 462.5 394.9 468.7 388.7L521.4 336L392.8 336C372.3 336 353.1 345.8 341 362.4L260.9 472.5C242.8 497.3 214 512 183.3 512L80 512C71.2 512 64 504.8 64 496C64 487.2 71.2 480 80 480L183.3 480C203.8 480 223 470.2 235.1 453.6L315.2 343.5C322 334.1 330.4 326.2 339.8 320C330.4 313.8 322 305.8 315.2 296.5L235 186.4C223 169.8 203.7 160 183.3 160L80 160C71.2 160 64 152.8 64 144z"
      fill="currentColor"
    />
  </svg>
</template>
